module.exports = __webpack_public_path__ + "static/media/thumbnail_ally-ups-cart@2x.96ee4c87.jpg";